import { APP_INITIALIZER, Provider } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export function loadEnvironmentConfig(
  http: HttpClient,
): () => Observable<unknown> {
  return () =>
    http
      .get<Partial<typeof environment>>('assets/config/environment_config.json')
      .pipe(
        tap((config) => {
          if (config && typeof config === 'object') {
            Object.assign(environment, config);
            console.info(
              'Environment-Konfiguration erfolgreich aus assets/config/environment_config.json geladen.',
            );
          }
        }),
        catchError((error) => {
          console.warn(
            'Keine externe assets/config/environment_config.json gefunden oder Fehler beim Laden, Standard-Environment wird genutzt:',
            error,
          );
          return of(null);
        }),
      );
}

export const ENVIRONMENT_CONFIG_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  useFactory: loadEnvironmentConfig,
  deps: [HttpClient],
  multi: true,
};
